import { TradePair } from '@ui/types/tradePair';
import { Nullable } from 'vitest';

export const getPairMaxLeverage = ({
  tradePair,
}: {
  tradePair: Nullable<TradePair>;
}) => {
  const leverageMargins = tradePair?.leverageMargins;

  const maxLeverage = leverageMargins?.reduce((max, value) => {
    return value.maxLeverage > max ? value.maxLeverage : max;
  }, 0);

  return maxLeverage;
};
